import React, { Fragment } from 'react';
import { createRoot } from 'react-dom/client';

import MarketShare from './components/MarketShare';
import CrossAppUsage from './components/CrossAppUsage';
import ComparisonSummary from './components/ComparisonSummary';
import Container from '../../../components/Container';
import MiniHeader from '../_shared/components/MiniHeader';
import TopAppsLine from '../_shared/components/TopAppsLine';
import SectionDivider from '../_shared/components/SectionDivider';
import AdditionalAppInsights from '../_shared/components/AdditionalAppInsights';
import CompetitorsComparisonsSection from '../_shared/components/CompetitorsComparisonsSection';
import useMobileView from '../../alchemy/сompetitive-intelligence-reports/shared/hooks/useMobileView';

import { rootNode, initParams } from './configs';

const { data } = initParams;

const comparisonApps = [{
  ...data.first_app,
  ...data.performance.first_app,
}, {
  ...data.second_app,
  ...data.performance.second_app,
}];

const FinanceAppComparisons = () => {
  const isMobileView = useMobileView();

  return (
    <Fragment>
      <MiniHeader
        apps={comparisonApps}
        date={data.published_date}
        isMobileView={isMobileView}
      />
      <TopAppsLine
        apps={comparisonApps}
        isMobileView={isMobileView}
      />
      <ComparisonSummary
        header={data.header}
        description={data.description}
        apps={comparisonApps}
        isMobileView={isMobileView}
      />
      <SectionDivider />
      <CrossAppUsage
        data={data.cross_app_usage_section}
        isMobileView={isMobileView}
      />
      <SectionDivider />
      <MarketShare
        data={data.market_share_section}
        isMobileView={isMobileView}
      />
      <SectionDivider />
      <div className="comparison-app-insights">
        <Container maxWidth={1248}>
          <AdditionalAppInsights
            formId={data.more_data_hubspot_form_id}
            portalId={data.more_data_hubspot_portal_id}
            buttons={data.click_baits_text}
          />
        </Container>
      </div>
      <CompetitorsComparisonsSection
        competitors={data.compatitors_section.top_competitors}
        comparisons={data.compatitors_section.top_comparisons}
        header={data.compatitors_section.header}
        subheader={data.compatitors_section.sub_header}
        isMobileView={isMobileView}
      />
    </Fragment>
  );
};

document.addEventListener('DOMContentLoaded', () => {
  const root = createRoot(rootNode);
  root.render(<FinanceAppComparisons />);
});
